import React, {createContext, useState} from 'react';

export const PaymentInfoContext = createContext({
  existCardId: '',
  setExistCardId:() => ({}),
});

const PaymentInfoProvider = ({ children }) => {
  const [existCardId, setExistCardId] = useState('');

  return (
    <PaymentInfoContext.Provider
      value={{
        existCardId,
        setExistCardId,
      }}
    >
      {children}
    </PaymentInfoContext.Provider>
  );
};

export default PaymentInfoProvider;
